import React from 'react'

import {InternalLinkOption} from "../../option"
import {PopoverMenuItemType} from "../../../../../popover-menu/popover-menu/const"
import PopoverMenuOptionWithSubmenu from "../../../../../popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"

type Props = {
    selectedId?     : ID
    options         : InternalLinkOption[]

    onClick         : {(index:number, option:InternalLinkOption): void}
}

export default function SlashDefaultMenuOptions (props: Props) {
    return (
        <>
            {_.map(props.options, (option:InternalLinkOption, key:number) => {
                const isHighlighted = option.id === props.selectedId

                if (option.type === PopoverMenuItemType.SUBMENU) {
                    return <PopoverMenuOptionWithSubmenu key            = {key}
                                                         id             = {option.id}
                                                         className      = "border-box w-100-percent"
                                                         option         = {option as any}
                                                         isHighlighted  = {isHighlighted}
                                                         highlightClass = "highlighted-radius"
                                                         onClick        = {(value: any, subOption: any)=>props.onClick(key, subOption)}/>
                }

                return <PopoverMenuOption key               = {key}
                                          id                = {option.id}
                                          className         = "border-box w-100-percent"
                                          option            = {option as any}
                                          isHighlighted     = {isHighlighted}
                                          highlightClass    = "highlighted-radius"
                                          onClick           = {()=>props.onClick(key, option)}/>
            })}
        </>
    )
}
